function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M24 0a24 24 0 110 48 24 24 0 010-48zm0 3.79a20.2 20.2 0 10-.01 40.41A20.2 20.2 0 0024 3.79zm3.91 25.43c3.5 0 6.5 1.98 8.03 4.87a15.62 15.62 0 01-23.88 0 9.09 9.09 0 018.03-4.87c.2 0 .39.03.58.09 1.06.34 2.17.56 3.33.56s2.28-.22 3.33-.57a2 2 0 01.58-.09zM24 11.62a7.17 7.17 0 110 14.34 7.17 7.17 0 010-14.35z",
  fillRule: "evenodd"
})));